/*******************************************************************************
 * Copyright (c) 2022 THERAYTEK
 *
 * All rights reserved.
 *
 * Contributors:
 *   James Worthington - Initial implementation
 *
 *******************************************************************************/

import React from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { withStyles } from '@mui/styles'
import Aboutus from '../../../components/Views/public/aboutus'
import Contactus from '../../../components/Views/public/Contactus'

const styles = theme => ({
    paper: {
        background: 'rgba(0, 0, 0, 0.5)',
    },
})

class AboutusPage extends React.Component {
    componentDidMount() {
        window.scrollTo(0, 0);

    }
    render() {
        return (
            <>
                <Aboutus />
                <Contactus />
            </>
        )
    }
}

AboutusPage.propTypes = {
    classes: PropTypes.object.isRequired,
}

function mapStateToProps() {
    return {}
}

const styledAboutusPage = withStyles(styles)(AboutusPage)
const connectedAboutusPage = connect(mapStateToProps)(styledAboutusPage)
export { connectedAboutusPage as AboutusPage }
